import { StaticImage } from "gatsby-plugin-image"
import * as styles from "./results-support.module.scss"
import Lottie from "@shared/uiNew/LazyLottie"
import markerAnimation from "@/shared/animations/animation_7.json"
import { useInView } from "react-intersection-observer"
import Button from "@shared/uiNew/Button/button"

const ResultsSupport: React.FC = () => {
  const { ref: sectionRef, inView } = useInView({
    triggerOnce: true,
    threshold: 0.66,
  })

  return (
    <section ref={sectionRef} className={styles.root}>
      <div className={styles.container}>
        <div className={styles.title}>
          С нами у вас точно получится дойти до{" "}
          <span className={styles.highlight}>
            результата
            {inView && <Lottie animationData={markerAnimation} loop={false} autoplay={true} />}
          </span>
        </div>

        <div className={styles.grid}>
          <div className={styles.card}>
            <div className={styles.image}>
              <StaticImage alt="Команда роста доведет до результата быстрее" src="./results-support_3.png" width={355} loading="eager" />
            </div>
            <div className={styles.heading}>
              <h3 className={styles.cardTitle}>Команда внедрения</h3>
              <p className={styles.cardText}>
                Полноценная команда из 5 человек под ваш проект. Разработаем стратегию, настроим сложные механики «под ключ» и доведем до конкретных
                бизнес-результатов. Идеально, если у вас нет ресурсов или экспертизы внутри.
              </p>
            </div>
          </div>

          <div className={styles.card}>
            <div className={styles.image}>
              <StaticImage alt="Персональный success‑менеджер" src="./results-support_2.png" width={374} loading="eager" />
            </div>
            <div className={styles.heading}>
              <h3 className={styles.cardTitle}>Специалист команды успеха</h3>
              <p className={styles.cardText}>
                Ваш персональный консультант по работе с платформой. Поможет с онбордингом, порекомендует сценарии под ваши задачи и ответит на любые вопросы
                по работе с платформой.
              </p>
            </div>
          </div>

          <div className={styles.card}>
            <div className={styles.image}>
              <StaticImage alt="Поддержка не оставит с вопросами один на один" src="./results-support_1.png" width={355} loading="eager" />
            </div>
            <div className={styles.heading}>
              <h3 className={styles.cardTitle}>Поддержка клиентов</h3>
              <p className={styles.cardText}>
                Берет на себя настройку, запуск и адаптацию всех механик под ваши цели без использования ресурсов вашей команды.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.buttonWrap}>
          <Button icon="arrow" text="Оставить заявку на демо" />
        </div>
      </div>
    </section>
  )
}

export default ResultsSupport
